import { Button, DatePicker, Dropdown, Input, Radio, Select, Typography } from 'antd'
import { apiGet, urls } from 'api'
import {
  IcCheck,
  IcCheckRound,
  IcInvoice,
  IcLoadMore,
  IcSO,
  IcSearch,
  IcTrash,
  IcUser,
  IcWhatsApp
} from 'assets/icons'
import { CardContainer, Table } from 'components'
import moment from 'moment'
import 'moment/locale/en-gb'
import ModalInspeksiDetail from 'pages/main/inspeksi/jadwal-inspeksi/components/ModalInspeksiDetail'
import { useMemo, useState } from 'react'
import { useQuery } from 'react-query'
import { useHistory, useLocation } from 'react-router-dom'
import { onReturnStatusTelahDikonfirmasiJadwalService, onReturnWaktuPerluDikonfirmasi } from 'utils'
import { openLinkWA } from 'utils/openLinkWA'

const InspeksiJadwalPerluTelahDikonfirmasiCard = ({
  refetchSchedule,
  onLogout,
  token,
  idCabang
}) => {
  const location = useLocation()
  const router = useHistory()

  const [listFilter, setListFilter] = useState({
    customers: [],
    places: [],
    stalls: []
  })
  const [modal, setModal] = useState({
    type: 'delete',
    data: {},
    show: false
  })

  const [filterConfirmed, setFilterConfirmed] = useState({
    totalRows: 0,
    offset: 0,
    limit: 10,
    listData: [],
    stall: '',
    customer: '',
    place: '',
    start_date: '',
    end_date: '',
    keywords: '',
    dateRangeValue: []
  })

  const [filterUnconfirmed, setFilterUnconfirmed] = useState({
    totalRows: 0,
    offset: 0,
    limit: 10,
    listData: [],
    stall: '',
    customer: '',
    place: '',
    start_date: '',
    end_date: '',
    keywords: '',
    dateRangeValue: []
  })

  const isTabUnconfirmed = useMemo(() => {
    return location?.hash !== '#inspection-confirmed' ? true : false
  }, [location?.hash])

  const [isShowDatePicker, setIsShowDatePicker] = useState(false)
  const handleChangeRangePicker = (dates, dateStrings) => {
    if (isTabUnconfirmed) {
      if (dates) {
        setFilterUnconfirmed((prev) => ({
          ...prev,
          dateRangeValue: dates,
          start_date: moment(dateStrings[0], 'DD/MM/YYYY').format('DD/MM/YYYY'),
          end_date: moment(dateStrings[1], 'DD/MM/YYYY').format('DD/MM/YYYY'),
          offset: 0
        }))
      } else {
        setFilterUnconfirmed((prev) => ({
          ...prev,
          dateRangeValue: [],
          start_date: '',
          end_date: '',
          offset: 0
        }))
      }
    } else {
      if (dates) {
        setFilterConfirmed((prev) => ({
          ...prev,
          dateRangeValue: dates,
          start_date: moment(dateStrings[0], 'DD/MM/YYYY').format('DD/MM/YYYY'),
          end_date: moment(dateStrings[1], 'DD/MM/YYYY').format('DD/MM/YYYY'),
          offset: 0
        }))
      } else {
        setFilterConfirmed((prev) => ({
          ...prev,
          dateRangeValue: [],
          start_date: '',
          end_date: '',
          offset: 0
        }))
      }
    }
  }

  const columnsUnitPerluDikonfirmasi = [
    {
      name: 'Tanggal',
      selector: (row) => (row?.date ? moment(row?.date).format('DD/MM/YYYY') : ''),
      width: '150px'
    },
    {
      name: 'Unit',
      selector: (row) => row?.unit_name,
      cell: (row) => (
        <div className="flex flex-col space-y-1">
          <span className="font-medium text-gray-700">{row?.unit_name}</span>
          <span className="font-normal text-gray-500">{`${row?.police_number ?? ''}`}</span>
        </div>
      )
    },
    {
      name: 'Pemilik',
      selector: (row) => row?.unit_owner
    },
    {
      name: 'Tempat',
      selector: (row) => row?.place,
      width: '150px'
    },
    {
      name: 'Waktu',
      selector: (row) => onReturnWaktuPerluDikonfirmasi(row.kuotaLayanan, row?.time)
    },
    {
      name: 'Action',
      width: '160px',
      button: true,
      ignoreRowClick: true,
      sortable: false,
      right: true,
      center: true,
      cell: (row) => (
        <div className="flex items-center justify-center self-center space-x-2 my-2">
          <Button
            className="flex flex-row items-center justify-center space-x-2 px-3 border-solid border border-[#12B76A] bg-[#12B76A] focus:bg-[#12B76A] focus:border-[#12B76A] hover:text-white hover:bg-[#12B76A] hover:border-[#12B76A] rounded-md"
            onClick={() => setModal({ show: true, type: 'konfirmasi', data: row })}>
            <IcCheckRound className="text-[#FFFFFF]" size={16} />
            <span className="font-medium text-[#FFFFFF]">Konfirmasi</span>
          </Button>
          <Button
            className="p-2 border-solid border border-[#FDA19B] hover:border-[#FDA19B] focus:border-[#FDA19B] rounded-md bg-white"
            onClick={() => {
              setModal({ show: true, type: 'delete', data: row })
            }}>
            <IcTrash className="text-primary-500" size={16} />
          </Button>
        </div>
      )
    }
  ]

  const columnsUnitTelahDikonfirmasi = [
    {
      name: 'Tanggal',
      selector: (row) => (row?.date ? moment(row?.date).format('DD/MM/YYYY') : ''),
      width: '150px'
    },
    {
      name: 'Unit',
      selector: (row) => row?.unit_name,
      cell: (row) => (
        <div className="flex flex-col space-y-1">
          <span className="font-medium text-gray-700">{row?.unit_name}</span>
          <span className="font-normal text-gray-500">{`${row?.police_number ?? ''}`}</span>
        </div>
      )
    },
    {
      name: 'Pemilik',
      selector: (row) => row?.unit_owner,
      width: '150px'
    },
    {
      name: 'Tempat',
      selector: (row) => row?.place,
      width: '100px'
    },
    {
      name: 'Stall',
      selector: (row) => (row?.stall ? row?.stall : '-'),
      width: '80px'
    },
    {
      name: 'Waktu',
      selector: (row) => row?.time,
      width: '80px',
      cell: (row) => row?.time
    },
    {
      name: 'Status',
      selector: (row) => onReturnStatusTelahDikonfirmasiJadwalService(row?.unit_status)
    },
    {
      name: 'Action',
      button: true,
      ignoreRowClick: true,
      sortable: false,
      right: true,
      center: true,
      width: '50px',
      cell: (row) => (
        <div className="flex items-center justify-center self-center">
          <Dropdown
            menu={{
              items: [
                row?.unit_status === 'Inspeksi Terjadwal' && {
                  key: '8',
                  label: (
                    <div className="flex items-center">
                      <IcCheck className="text-success-500 mr-2" size={16} />
                      <Typography.Text className="text-success-500 text-sm">
                        Konfirmasi Kehadiran
                      </Typography.Text>
                    </div>
                  ),
                  onClick: () =>
                    setModal({
                      show: true,
                      type: 'konfirmasi-kehadiran',
                      data: row
                    })
                },
                row?.unit_status === 'Sedang Berlangsung' && {
                  key: '2',
                  label: (
                    <div className="flex items-center">
                      <IcUser className="text-gray-700 mr-2" size={16} />
                      <Typography.Text className="text-gray-700 text-sm">
                        Konfirmasi Inspektor
                      </Typography.Text>
                    </div>
                  ),
                  onClick: () =>
                    setModal({
                      show: true,
                      type: 'konfirmasi-inspektor',
                      data: row
                    })
                },
                {
                  key: '3',
                  label: (
                    <div className="flex items-center">
                      <IcSearch className="text-gray-700 mr-2" size={16} />
                      <Typography.Text className="text-gray-700 text-sm">
                        Detail Inspeksi
                      </Typography.Text>
                    </div>
                  ),
                  onClick: () => router.push(`/inspeksi/jadwal-inspeksi/${row?.id}/detail-inspeksi`)
                },
                {
                  key: '4',
                  label: (
                    <div className="flex items-center">
                      <IcSO className="text-gray-700 mr-2" size={16} />
                      <Typography.Text className="text-gray-700 text-sm">Lihat SO</Typography.Text>
                    </div>
                  ),
                  onClick: () => router.push(`/inspeksi/jadwal-inspeksi/${row?.id}/sales-order`)
                },
                {
                  key: '5',
                  label: (
                    <div className="flex items-center">
                      <IcInvoice className="text-gray-700 mr-2" size={16} />
                      <Typography.Text className="text-gray-700 text-sm">Invoice</Typography.Text>
                    </div>
                  ),
                  onClick: () => router.push(`/inspeksi/jadwal-inspeksi/${row?.id}/invoice`)
                },
                {
                  key: '6',
                  label: (
                    <div className="flex items-center">
                      <IcWhatsApp className="text-gray-700 mr-2" size={16} />
                      <Typography.Text className="text-gray-700 text-sm">Whatsapp</Typography.Text>
                    </div>
                  ),
                  onClick: () => openLinkWA(row?.phone_number)
                }
              ]
            }}
            placement="bottomRight"
            trigger={['click']}>
            <div className="cursor-pointer" onClick={(e) => e.preventDefault()}>
              <IcLoadMore className="text-gray-700" size={16} />
            </div>
          </Dropdown>
        </div>
      )
    }
  ]

  // API
  // Get list customers
  useQuery({
    queryKey: ['list-customers', idCabang],
    refetchOnWindowFocus: false,
    queryFn: async () => {
      const res = await apiGet({
        token,
        url: `${urls?.inspection.prefix}/${urls?.inspection.customers}/${idCabang}`,
        onLogout
      })
      return res
    },
    onSuccess: (res) => {
      setListFilter((prev) => ({ ...prev, customers: res?.resData?.data ?? [] }))
    }
  })

  // Get list stall
  useQuery({
    queryKey: ['list-stall', idCabang],
    refetchOnWindowFocus: false,
    queryFn: async () => {
      const res = await apiGet({
        token,
        url: `${urls?.master?.prefix}/${urls?.master.stall}/${idCabang}`,
        onLogout
      })
      return res
    },
    onSuccess: (res) => {
      setListFilter((prev) => ({ ...prev, stalls: res?.resData?.data ?? [] }))
    }
  })

  // Get Unconfirmed
  const {
    isLoading: isLoadingUnconfirmed,
    refetch: refetchUnconfirmed,
    isFetching: isFetchingUnconfirmed
  } = useQuery({
    queryKey: [
      'unconfirmed',
      idCabang,
      filterUnconfirmed?.keywords,
      filterUnconfirmed?.stall,
      filterUnconfirmed?.customer,
      filterUnconfirmed?.place,
      filterUnconfirmed?.start_date,
      filterUnconfirmed?.end_date,
      filterUnconfirmed?.limit,
      filterUnconfirmed?.offset
    ],
    refetchOnWindowFocus: false,
    queryFn: async () => {
      const res = await apiGet({
        token,
        url: `${urls?.inspection?.prefix}/${urls?.inspection.schedules}/${idCabang}?${urls?.inspection?.schedulesUnconfirmed}&keywords=${filterUnconfirmed?.keywords}&stall=${filterUnconfirmed?.stall}&owner=${filterUnconfirmed?.customer}&place=${filterUnconfirmed?.place}&start_date=${filterUnconfirmed?.start_date}&end_date=${filterUnconfirmed?.end_date}&limit=${filterUnconfirmed?.limit}&offset=${filterUnconfirmed?.offset}`,
        onLogout
      })
      return res
    },
    onSuccess: (res) => {
      setFilterUnconfirmed((prev) => ({
        ...prev,
        listData: res?.resData?.data ?? [],
        totalRows: res?.resData?.meta?.total
      }))
    }
  })

  // Get Confirmed
  const {
    isLoading: isLoadingConfirmed,
    refetch: refetchConfirmed,
    isFetching: isFetchingConfirmed
  } = useQuery({
    queryKey: [
      'confirmed',
      idCabang,
      filterConfirmed?.keywords,
      filterConfirmed?.stall,
      filterConfirmed?.customer,
      filterConfirmed?.place,
      filterConfirmed?.start_date,
      filterConfirmed?.end_date,
      filterConfirmed?.limit,
      filterConfirmed?.offset
    ],
    refetchOnWindowFocus: false,
    queryFn: async () => {
      const res = await apiGet({
        token,
        url: `${urls?.inspection?.prefix}/${urls?.inspection.schedules}/${idCabang}?${urls?.inspection?.schedulesConfirmed}&keywords=${filterConfirmed?.keywords}&stall=${filterConfirmed?.stall}&owner=${filterConfirmed?.customer}&place=${filterConfirmed?.place}&start_date=${filterConfirmed?.start_date}&end_date=${filterConfirmed?.end_date}&limit=${filterConfirmed?.limit}&offset=${filterConfirmed?.offset}`,
        onLogout
      })
      return res
    },
    onSuccess: (res) => {
      setFilterConfirmed((prev) => ({
        ...prev,
        listData: res?.resData?.data ?? [],
        totalRows: res?.resData?.meta?.total
      }))
    }
  })

  // *Table state
  const handlePerRowsChange = (newPerPage) => {
    if (isTabUnconfirmed) {
      setFilterUnconfirmed((prev) => ({
        ...prev,
        limit: newPerPage,
        offset: 0
      }))
    } else {
      setFilterConfirmed((prev) => ({
        ...prev,
        limit: newPerPage,
        offset: 0
      }))
    }
  }

  const onChangePage = (page) => {
    if (isTabUnconfirmed) {
      setFilterUnconfirmed((prev) => ({
        ...prev,
        offset: page
      }))
    } else {
      setFilterConfirmed((prev) => ({
        ...prev,
        offset: page
      }))
    }
  }

  return (
    <div className="flex flex-col w-full space-y-5">
      <ModalInspeksiDetail
        isOpen={modal?.show}
        type={modal?.type}
        data={modal?.data}
        listStall={listFilter?.stalls}
        onCancel={() => setModal({ ...modal, show: false })}
        onLogout={onLogout}
        token={token}
        refetchConfirmed={refetchConfirmed}
        refetchUnconfirmed={refetchUnconfirmed}
        refetchSchedule={refetchSchedule}
        idCabang={idCabang}
      />
      <CardContainer minHeight="60%">
        <div className="flex flex-col space-y-5">
          <div className="flex-1 w-full">
            <Radio.Group
              className="custom-radio mb-2"
              value={isTabUnconfirmed ? 0 : 1}
              size="large">
              <Radio.Button
                className="custom-radio-left"
                onClick={() =>
                  router.push({
                    pathname: `/workshop-management/${idCabang}`,
                    hash: 'inspection-unconfirmed'
                  })
                }
                value={0}>
                Perlu Dikonfirmasi
              </Radio.Button>
              <Radio.Button
                className="custom-radio-right"
                onClick={() =>
                  router.push({
                    pathname: `/workshop-management/${idCabang}`,
                    hash: 'inspection-confirmed'
                  })
                }
                value={1}>
                Telah Dikonfirmasi
              </Radio.Button>
            </Radio.Group>
          </div>
          <span className="font-semibold text-2xl text-gray-900">
            {isTabUnconfirmed ? 'Daftar Unit Perlu Konfirmasi' : 'Unit Terkonfirmasi'}
          </span>
          <div className="flex justify-between mb-5 gap-2">
            <div className="flex items-center gap-4">
              <Select
                className="custom-table-limit"
                style={{ width: '150px' }}
                value={isTabUnconfirmed ? filterUnconfirmed?.customer : filterConfirmed?.customer}
                onChange={(e) =>
                  isTabUnconfirmed
                    ? setFilterUnconfirmed((prev) => ({ ...prev, customer: e, offset: 0 }))
                    : setFilterConfirmed((prev) => ({ ...prev, customer: e, offset: 0 }))
                }>
                <Select.Option className="custom-table-limit-option" value="">
                  Semua Pemilik
                </Select.Option>
                {listFilter?.customers?.map((item, idx) => (
                  <Select.Option
                    key={idx}
                    className="custom-table-limit-option"
                    value={item?.owner_name}>
                    {item?.owner_name}
                  </Select.Option>
                ))}
              </Select>
              <Select
                className="custom-table-limit"
                style={{ width: '150px' }}
                value={isTabUnconfirmed ? filterUnconfirmed?.place : filterConfirmed?.place}
                onChange={(e) =>
                  isTabUnconfirmed
                    ? setFilterUnconfirmed((prev) => ({ ...prev, place: e, offset: 0 }))
                    : setFilterConfirmed((prev) => ({ ...prev, place: e, offset: 0 }))
                }>
                <Select.Option className="custom-table-limit-option" value="">
                  Semua Tempat
                </Select.Option>
                <Select.Option className="custom-table-limit-option" value={true}>
                  Bengkel
                </Select.Option>
                <Select.Option className="custom-table-limit-option" value={false}>
                  Rumah
                </Select.Option>
              </Select>
              <Select
                className="custom-table-limit"
                style={{ width: '150px' }}
                value={isTabUnconfirmed ? filterUnconfirmed?.stall : filterConfirmed?.stall}
                onChange={(e) =>
                  isTabUnconfirmed
                    ? setFilterUnconfirmed((prev) => ({ ...prev, stall: e, offset: 0 }))
                    : setFilterConfirmed((prev) => ({ ...prev, stall: e, offset: 0 }))
                }>
                <Select.Option className="custom-table-limit-option" value="">
                  Semua Stall
                </Select.Option>
                {listFilter?.stalls?.map((item, idx) => (
                  <Select.Option key={idx} className="custom-table-limit-option" value={item}>
                    {`Stall ${item}`}
                  </Select.Option>
                ))}
              </Select>
              <DatePicker.RangePicker
                onOpenChange={(open) => setIsShowDatePicker(open)}
                onChange={handleChangeRangePicker}
                format="DD/MM/YYYY"
                open={isShowDatePicker}
                value={
                  isTabUnconfirmed
                    ? filterUnconfirmed?.dateRangeValue
                    : filterConfirmed?.dateRangeValue
                }
                placeholder={['Tanggal Mulai', 'Tanggal Akhir']}
                popupClassName="custom-date-picker-dropdown"
                className="custom-date-picker py-[6px] w-fit rounded-md hover:cursor-pointer font-medium text-gray-700 focus:border-primary-500 active:border-primary-500"
              />
            </div>
            <Input
              className="w-1/4 rounded-md py-1.5"
              placeholder="Pencarian"
              prefix={<IcSearch className="text-gray-400" />}
              value={isTabUnconfirmed ? filterUnconfirmed?.keywords : filterConfirmed?.keywords}
              onChange={(e) => {
                isTabUnconfirmed
                  ? setFilterUnconfirmed((prev) => ({
                      ...prev,
                      keywords: e?.target?.value,
                      offset: 0
                    }))
                  : setFilterConfirmed((prev) => ({
                      ...prev,
                      keywords: e?.target?.value,
                      offset: 0
                    }))
              }}
            />
          </div>
          <Table
            columns={isTabUnconfirmed ? columnsUnitPerluDikonfirmasi : columnsUnitTelahDikonfirmasi}
            data={isTabUnconfirmed ? filterUnconfirmed?.listData : filterConfirmed?.listData}
            pending={
              isTabUnconfirmed
                ? isLoadingUnconfirmed ?? isFetchingUnconfirmed
                : isLoadingConfirmed ?? isFetchingConfirmed
            }
            totalRows={isTabUnconfirmed ? filterUnconfirmed?.totalRows : filterConfirmed?.totalRows}
            handlePerRowsChange={handlePerRowsChange}
            pageSize={isTabUnconfirmed ? filterUnconfirmed?.limit : filterConfirmed?.limit}
            page={isTabUnconfirmed ? filterUnconfirmed?.offset : filterConfirmed?.offset}
            onChangePrevPage={() => {
              if (isTabUnconfirmed) {
                if (filterUnconfirmed?.offset > 0) {
                  onChangePage(filterUnconfirmed?.offset - filterUnconfirmed?.limit)
                }
              } else {
                if (filterConfirmed?.offset > 0) {
                  onChangePage(filterConfirmed?.offset - filterConfirmed?.limit)
                }
              }
            }}
            onChangeNextPage={() => {
              if (isTabUnconfirmed) {
                if (
                  filterUnconfirmed?.totalRows >
                  filterUnconfirmed?.limit + filterUnconfirmed?.offset
                ) {
                  onChangePage(filterUnconfirmed?.offset + filterUnconfirmed?.limit)
                }
              } else {
                if (filterConfirmed?.totalRows > filterConfirmed?.limit + filterConfirmed?.offset) {
                  onChangePage(filterConfirmed?.offset + filterConfirmed?.limit)
                }
              }
            }}
          />
        </div>
      </CardContainer>
    </div>
  )
}

export default InspeksiJadwalPerluTelahDikonfirmasiCard
